import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import InfiniteScroll from "../../Components/Functionality/InfiniteScrollList";
import Container from "../../Components/UI/Container";
import { useDebatesStatusStore, useUserStore } from "../../Context/store";
import { useSubworkspaceStore } from "../../Context/store";
import {
  useDebateReadMutation,
  useGetSemiPublicUserWiseDebatedList,
} from "../../Web-Hooks/Debate/use-debate";
import Posts from "../Posts/Posts";

const Debated = () => {
  const location = useLocation();
  const { pathname } = location;
  const opponentId = pathname.slice(1).split("/")[1];
  const { selectedSubWorkspace } = useSubworkspaceStore();
  const { user } = useUserStore();
  const QueryKey = [
    "debated-subworkspace",
    user?.userId,
    selectedSubWorkspace?.subWorkSpaceId,
    opponentId,
  ];
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useGetSemiPublicUserWiseDebatedList(
    user?.userId,
    selectedSubWorkspace?.subWorkSpaceId,
    opponentId
  );
  const { mutateAsync: readStatus, isPending } = useDebateReadMutation();

  const { currentForumStatus } = useDebatesStatusStore();

  const hasNewDebates =
    isLoading || isPending
      ? false
      : opponentId
      ? currentForumStatus?.sections?.semiPublicDebatedFeed?.userSections?.includes(
          opponentId
        )
      : currentForumStatus?.sections?.semiPublicDebatedFeed?.userSections
          ?.length > 0;

  useEffect(() => {
    readStatus({
      userId: user?.userId,
      subWorkSpaceId: selectedSubWorkspace?.subWorkSpaceId,
      sectionType: "semiPublicDebated",
      opponentId: opponentId,
    });
  }, [
    readStatus,
    user?.userId,
    selectedSubWorkspace?.subWorkSpaceId,
    opponentId,
  ]);

  const handleRefetch = async() => {
    readStatus({
      userId: user?.userId,
      subWorkSpaceId: selectedSubWorkspace?.subWorkSpaceId,
      sectionType: "semiPublicDebated",
      opponentId: opponentId,
    });
    const response  = await refetch();
    return response
  };

  return (
    <Container>
      <InfiniteScroll
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
        hasNewData={hasNewDebates}
        refetch={handleRefetch}
        queryKey={QueryKey}
      >
        <Posts
          apiType={pathname}
          user={user}
          isLoading={isLoading && !isFetchingNextPage}
          AllDebates={data?.pages?.flatMap((page) => page.debateList)} // Combine all pages
        />
      </InfiniteScroll>
    </Container>
  );
};

export default Debated;
